export const getUserMetadata = (state) => state.userMetadata;



// WEBPACK FOOTER //
// ./src/selectors/userMetadata.js